import { StyleSheet, Text, View, Image, TouchableOpacity, Dimensions,  BackHandler, Button, StatusBar, ScrollView, ImageBackground, TextInput, TouchableWithoutFeedback, FlatList, Alert} from 'react-native';
import React, {useRef, useState, useEffect, Component} from 'react';
import { FontAwesome5, Feather, MaterialIcons } from '@expo/vector-icons'
import AppLoader, { showLoader, loaderRef, hideLoader } from './AppLoader';
import { SafeAreaView } from 'react-native-safe-area-context';
import { createRecentTable, getRecents, SaveRecents } from './getData';
import * as ScreenOrientation from 'expo-screen-orientation';
import AwesomeAlert from 'react-native-awesome-alerts';
import AsyncStorage from '@react-native-async-storage/async-storage';

  
export default class Recents extends Component {
  constructor(props) {
    super(props);
    this.state = {
           user: [],
           list: [],
           isLoggedIn: false,
            error: '',
            id: '',
              
            
        }

        
  
      }
   
      
      componentDidMount() {
        showLoader();
        //get user from asyncstorage
        AsyncStorage.getItem('user').then((user) => {
          if (user) {
            //parse json
             user = JSON.parse(user);
            //console.log(user.id)
          
            this.setState({isLoggedIn: true, user: user, id: user.id}, () => {
              this.getRecents()
              });
        
          } else {
            this.setState({isLoggedIn: false});
           
           hideLoader()
            this.props.navigation.navigate('Profile');
          }
        }).catch((err) => {
          console.log(err);
        }
        );
        
        
         // getRecents();
       //fetch movies from ios.breketefamily.com/getMovies.php
      // console.log(this.state)
        
      
      }
 getRecents = () => {
  fetch('https://ios.breketefamily.com/getRecents.php?id='+this.state.id)
  .then((response) => response.json())
  .then((responseJson) => {
    //  console.log(responseJson.list[0])
    if(responseJson.status == 0){
      this.setState({
        list: responseJson.list,
      }, () => {
        hideLoader();
        
      })
      
    }else{
      hideLoader();
      this.setState({error: responseJson.message})
    }

   
  }
  )
  .catch((error) => {
    hideLoader();
    console.error(error);
  }
  );
  }
render(){
  
  return (
    <SafeAreaView style={{flex:1}}>
    <View style={{flex:1}}>
      <AppLoader ref = { loaderRef } />
     
   
      {/*backbutton*/ }
    {/*render list */}
   
   {this.state.list.map((item) => {
    
    //loop through item.length
      //console.log(i)
      return(
        <TouchableOpacity key={item.id} onPress={() => this.props.navigation.navigate('Player', {movie: {id:item.id, video_url: 'https://bkpanel.breketefamily.com/public/upload/source/'+item.video_url}})}>
        <View style={{flexDirection:'row', padding:10, borderBottomColor:'#ccc', borderBottomWidth:1}}>
        <Image style={{width:100, height:100}} source={{uri: 'https://bkpanel.breketefamily.com/public/upload/thumbs/'+item.video_image}} />
        <View style={{flex:1, marginLeft:10}}>
        <Text style={{fontSize:18, fontWeight:'bold'}}>{item.video_title}</Text>
        <Text style={{fontSize:14, color:'#666'}}>{item.duration}</Text>
        </View>
        </View>
        </TouchableOpacity>
      )
    })}

      
      {/*end render list */}
  {this.state.error &&  <Text style={{textAlign:'center', fontSize:20, marginTop:100}}>No Recent Movies</Text>}
  </View>
    </SafeAreaView>

  );
}
 

}

const styles = StyleSheet.create({


// CAROUSEL STYLES

carouselImage: {
    width: 200, 
    height: 320, 
    borderRadius: 10, 
    alignSelf: 'center',
    backgroundColor: 'rgba(0,0,0,0.9)'
},
carouselText: {
    paddingLeft: 14,
    color: 'white', 
    position: 'absolute', 
    bottom: 10, 
    left: 2, 
    fontWeight: 'bold'
},
carouselIcon: {
    position: 'absolute', 
    top: 15, 
    right: 15
},
carouselContentContainer: {
    flex: 1,
    backgroundColor: '#000',
    height: 720,
    paddingHorizontal: 14
  },
SearchboxContainer: {
    flexDirection: 'row',
    marginVertical: 20, 
    width: '95%',
    alignSelf: 'center', 
    backgroundColor: '#fff', 
    elevation: 10,
    borderRadius: 4,
  },
  Searchbox: {
    padding: 12,
    paddingLeft: 20,
    fontSize: 16,
  },
  SearchboxIcon: {
    position: 'absolute', 
    right: 20, 
    top: 14
  },
  ImageBg: {
    flex: 1,
    height: null,
    width: null,
    opacity: 1,
    justifyContent: 'flex-start',  
  },
  carouselContainerView: {
    width: '100%',
    height:350 ,
    justifyContent: 'center',
    alignItems: 'center',
},
  carousel: {
    flex:1,
    overflow: 'visible',
} ,
movieInfoContainer: {
  flexDirection: 'row', 
  marginTop: 16, 
  justifyContent: 'space-between', 
  width: Dimensions.get('window').width - 14
},
movieName: {
  paddingLeft: 14,
  color: 'white', 
  fontWeight: 'bold', 
  fontSize: 20,
  marginBottom: 6
},
movieStat: {
  paddingLeft: 14,
  color: 'white', 
  fontWeight: 'bold', 
  fontSize: 14, 
  opacity: 0.8
},
playIconContainer: {
  backgroundColor: '#212121',
  padding: 18,
  borderRadius: 40,
  justifyContent: 'center',
  alignItems: 'center',
  elevation: 25,
  borderWidth: 4,
  borderColor: 'rgba(2, 173, 148, 0.2)',
  marginBottom: 14
}
});
